import { FiCheck, FiTarget, FiUsers, FiTrendingUp } from 'react-icons/fi'
import './AboutUs.css'
import { useTranslation } from 'react-i18next';


const AboutUs = () => {
    const { t } = useTranslation();
   return (
    <section className="about-us" id="about">
      <div className="container">
        <div className="about-grid">
          <div className="about-content">
            <h2>{t('about.title')}</h2>
            <p className="about-lead">{t('about.lead')}</p>
            <p>{t('about.description')}</p>

            <div className="about-values">
              {t('about.values', { returnObjects: true }).map((value, index) => (
                <div className="value-item" key={index}>
                  <div className="value-icon">
                    {index === 0 ? <FiUsers /> : index === 1 ? <FiTarget /> : <FiTrendingUp />}
                  </div>
                  <div className="value-content">
                    <h4>{value.title}</h4>
                    <p>{value.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="about-image">
            <img 
              src="https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" 
              alt={t('about.imageAlt')} 
              className="team-image"
            />
            <div className="about-stats">
              {t('about.stats', { returnObjects: true }).map((stat, index) => (
                <div className="about-stat" key={index}>
                  <span className="stat-number">{stat.number}</span>
                  <span className="stat-text">{stat.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};


export default AboutUs